// easter-formula-input

// WebComponents
if (!customElements.get("easter-formula-input")) {
  customElements.define(
    "easter-formula-input",
    class EasterFormulaInput extends HTMLElement {
      constructor() {
        super();
      }
      get usedCodes() {
        const codesFromCookie = this.getCookie("easterCodes");
        const codesFromScript = document.querySelector("[data-easter-used-codes]").textContent;
        const codesFromCookieArray = codesFromCookie ? codesFromCookie.split(",") : [];
        const codesFromScriptArray = codesFromScript ? codesFromScript.split(",") : [];

        return [...new Set([...codesFromCookieArray, ...codesFromScriptArray])];
      }
      setCookie(eggId, target) {
        let date = new Date();
        date.setHours(23, 59, 59, 59);

        document.cookie = `${eggId}=${target}; expires=${date.toUTCString()}; path=/`;
      }
      checkCookie(eggId) {
        let cookie = document.cookie;
        return cookie.includes(`${eggId}=`);
      }
      getCookie(n) {
        let a = `; ${document.cookie}`.match(`;\\s*${n}=([^;]+)`);
        return a ? a[1] : "";
      }
      //  "test1",  
      //     "test2",  
      //     "test3",  
      //     "test4",  
      //     "test5",  
      //     "test6",  
      //     "test7",  
      //     "test8",  
      //     "test9",  
      //     "test10",  
      //     "test11",  
      //     "test12",  
      //     "test13",  
      //     "test14",  
      //     "test15",  
      //     "test16",  
      //     "test17",  
      //     "test18",  
      //     "test19",  
      //     "test20",  
      //     "test21",  
      //     "test22",  
      //     "test23",  
      //     "test24",  
      //     "test25",  
      //     "test26",  
      //     "test27",  
      //     "test28",  
      //     "test29",  
      //     "test30",  
      //     "test31",  
      //     "test32",  
      //     "test33",  
      //     "test34",  
      //     "test35",  
      //     "test36",  
      //     "test37",  
      //     "test38",  
      //     "test39",  
      //     "test40",  
      //     "test41",  
      //     "test42",  
      //     "test43",  
      //     "test44",  
      //     "test45",  
      //     "test46",  
      //     "test47",  
      //     "test48",  
      //     "test49",  
      //     "test50",  
      //     "test51",  
      //     "test52",  
      //     "test53",  
      //     "test54",  
      //     "test55",  
      //     "test56",  
      //     "test57",  
      //     "test58",  
      //     "test59",  
      //     "test60",  
      //     "test61",  
      //     "test62",  
      //     "test63",  
      //     "test64",  
      //     "test65",  
      //     "test66",  
      //     "test67",  
      //     "test68",  
      //     "test69",  
      //     "test70",  
      //     "test71",  
      //     "test72",  
      //     "test73",  
      //     "test74",  
      //     "test75",  
      //     "test76",  
      //     "test77",  
      //     "test78",  
      //     "test79",  
      //     "test80",  
      //     "test81",  
      //     "test82",  
      //     "test83",  
      //     "test84",  
      //     "test85",  
      //     "test86",  
      //     "test87",  
      //     "test88",  
      //     "test89",  
      //     "test90",  
      //     "test91",  
      //     "test92",  
      //     "test93",  
      //     "test94",  
      //     "test95",  
      //     "test96",  
      //     "test97",  
      //     "test98",  
      //     "test99",  
      //     "test100", 
      connectedCallback() {
        this.codes = [
          "rU'r'U2rUr'RUR'",
          "M2UMU2M'UM2",
          "R2 F2 R U2 R U2' R' F R U R' U' R' F R2",
          "M2 U M2 U2 M2 U M2",
          "x R2 D2 R U R' D2 R U' R x'",
          "M2 U’M2 U2 M2 U’M2",
          "x R2 F R F' R U2 r' U r U2 x'",
          "R U R' F' R U R' U' R' F R2 U' R'",
          "R U R' U' R' F R2 U' R' U' R U R' F'",
          "F R U R' U' F'",
          "F R U R' U' SR U R' U' FW'",
          "RW' U' R U M'",
          "R' F R F' R U' R'",
          "R U R D R' U' R D' R2",
          "R U R' U' FW' U' F U S",
          "R2 U' S U2 SU R2",
          "R’ D’ R U’ R’ D R",
          "r U R' U R U' R' U R U2 r'",
          "R U R' U R' F R F' R U2 R'",
          "M' R' U' R U' R' U2 R U' M",
          "r UR' UR U2 r'",
          "R’ U’ R’ F R F’ U R",
          "R U2' R2' F R F' U2 r R' U R U' r'",
          "M2 U' M2 U2 M2 U' M2",
          "M2 U2 M2 U’ M2 U2 M2",
          "Mr.PuzzleGAN",
          "PODIX",
          "S R' S'",
          "JUST4FUN",
          "Beyond building, Beyond illuminating",
          "(R U' R') U y'(R' U2 R) U(R' U2 R)",
          "R' F R U R' F' R F U' F'",
          "R U R' U R U2 R' U2 R U2 R' U' R U' R'"
        ];

        this.input = this.querySelector("input");
        this.button = this.querySelector(".easter-2026-spin-button");
        this.success = this.querySelector(".easter-2026-spin-success");
        this.error = this.querySelector(".easter-2026-spin-error");

        console.log("input", this.input, this);
        this.button.addEventListener("click", () => {
          // this.usedCodes 不包含此次输入的码
          console.log("this.usedCodes", this.usedCodes);
          if (this.usedCodes.includes(this.input.value)) {
            // 验证码已使用
            if (this.success.classList.contains("active")) {
              this.success.classList.remove("active");
            }
            this.error.classList.add("active");
            this.error.innerText =
              "The formula has been used. Try Another One 😃";
            setTimeout(() => {
              this.error.classList.remove("active");
            }, 6000);
          } else if (this.codes.indexOf(this.input.value) > -1) {
            // console.log("验证通过");
            // 加入 cookie

            const _usedCodes = this.usedCodes;
            _usedCodes.push(this.input.value);

            const qikifyFormFormulaInput = document.querySelector(`input[name="contact[Code]"]`);
            qikifyFormFormulaInput.value = this.input.value;
            qikifyFormFormulaInput.dispatchEvent(
              new Event("input", { bubbles: true }),
            );
            this.setCookie("easterCodes", _usedCodes.toString());
            document
              .querySelector("easter-spin-wheel")
              .dispatchEvent(new CustomEvent("spin"));
            if (this.error.classList.contains("active")) {
              this.error.classList.remove("active");
            }

            this.success.classList.add("active");
            setTimeout(() => {
              this.success.classList.remove("active");
            }, 3000);
          } else {
            if (this.success.classList.contains("active")) {
              this.success.classList.remove("active");
            }
            this.error.innerText = "Incorrect Code. Try Again 😃";
            this.error.classList.add("active");
            setTimeout(() => {
              this.error.classList.remove("active");
            }, 6000);
          }
        });
      }
    },
  );
}

// easter-spin-wheel
if (!customElements.get("easter-spin-wheel")) {
  customElements.define(
    "easter-spin-wheel",
    class EasterSpinWheel extends HTMLElement {
      constructor() {
        super();
      }
      setCookie(eggId, target) {
        let date = new Date();
        date.setHours(23, 59, 59, 59);

        document.cookie = `${eggId}=${target}; expires=${date.toUTCString()}; path=/`;
      }
      checkCookie(eggId) {
        let cookie = document.cookie;
        return cookie.includes(`${eggId}=`);
      }
      getCookie(n) {
        let a = `; ${document.cookie}`.match(`;\\s*${n}=([^;]+)`);
        return a ? a[1] : "";
      }
      stopLoading() {
        this.closest(".easter-2026-spin-section").classList.remove("loading");
        this.qikifyForm = this.querySelector(
          ".bcontact-embed form.bcontact-form",
        );
        this.qikifyFormEmailInput = this.qikifyForm.querySelector(
          `input[name="contact[email]"]`,
        );
        this.qikifyFormPrizeInput = this.qikifyForm.querySelector(
          `input[name="contact[Spin Prize]"]`,
        );
        this.qikifyFormFormulaInput = this.qikifyForm.querySelector(
          `input[name="contact[Code]"]`,
        );
        this.qikifyFormSubmitButton =
          this.qikifyForm.querySelector(`.bcontact-submit-btn`);

        this.qikifyFormEmailInput.value = this.json.email;
        this.qikifyFormEmailInput.dispatchEvent(
          new Event("input", { bubbles: true }),
        );
      }
      checkQikifyForm() {
        if (this.querySelector(".bcontact-embed form.bcontact-form")) {
          this.stopLoading();
        } else {
          //  使用 observer 监听 .bcontact-embed 元素出现
          const observer = new MutationObserver(() => {
            if (this.querySelector(".bcontact-embed form.bcontact-form")) {
              this.stopLoading();
              observer.disconnect(); // 停止监听
            }
          });
          observer.observe(this, { childList: true });
        }
      }
      async downloadImage() {
        if (window.prizeStyle) {
          const imageUrl = `https://cdn.shopify.com/s/files/1/0703/2389/6537/files/gan-share-${window.prizeStyle}.png`;

          try {
            const response = await fetch(imageUrl);
            const blob = await response.blob();

            const blobUrl = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = "share-image.jpg";
            document.body.appendChild(a);
            a.click();

            a.remove();
            window.URL.revokeObjectURL(blobUrl);
          } catch (err) {
            alert("Download failed");
          }
        }
      }
      selectByWeight(weights) {
        // 计算权重总和
        let total = 0;
        for (let w of weights) total += w;
        // 生成随机数
        let rand = Math.random() * total;
        let acc = 0;
        for (let i = 0; i < weights.length; i++) {
          acc += weights[i];
          if (rand < acc) return i;
        }
        return weights.length - 1; // 理论上不会走到这里，但防止浮点误差
      }
      handleSpin() {
        if (this.isSpinning) return;

        // 1. 随机选择一个奖品索引 (0 ~ N-1)
        // const randIndex = Math.floor(Math.random() * this.N);
        // this.currentPrizeIndex = randIndex;
        // this.capIndex = Math.floor(Math.random() * this.capSize);

        // 1.1 获取所有未中奖奖品的索引和对应权重
        const wonIndicesFromCookie = this.getCookie("easterWon").split(",");
        const wonIndicesFromScript = document
          .querySelector("[data-easter-won]")
          .textContent.split(",");
        const wonIndices = [...new Set([...wonIndicesFromCookie, ...wonIndicesFromScript])];

        const availableIndices = [];
        const weights = [];
        const cubeInventory = JSON.parse(
          document.querySelector("[data-easter-prize-inventory]").textContent,
        );
        for (let i = 0; i < 13; i++) {
          if (!wonIndices.includes(this.prizes[i].name) && !(i == 0 && cubeInventory.inventory[i] <= 0)) {
            availableIndices.push(i);
            weights.push(this.prizes[i].weight);
          } else {
            // 用不限量的折扣码替代已中过的限量奖品
            availableIndices.push(Date.now() % 3 + 6);
            weights.push(1);
          }
        }

        if (availableIndices.length === 0) {
          console.log("所有奖品已抽完！");
          return;
        }

        // 1.2 根据权重选择其中一个索引（返回的是 availableIndices 中的位置）
        const selectedPos = this.selectByWeight(weights);
        const randIndex = availableIndices[selectedPos];
        // console.log("availableIndices", availableIndices, "wonIndices", wonIndices);
        // const randIndex = 2;

        // 1.3 记录本次中奖索引
        let wheelIndex = randIndex;
        this.currentPrizeIndex = randIndex;
        // 本地记录已抽中的奖品
        const newWonIndices = [...wonIndices, this.prizes[randIndex].name];
        // newWonIndices 数组去重
        const uniqueWonIndices = [...new Set(newWonIndices)];

        this.setCookie("easterWon", uniqueWonIndices.toString());
    
        if (randIndex == 1 || randIndex == 2 || randIndex == 3 || randIndex == 4 || randIndex == 5) {
          wheelIndex = 1;
        }
        if (randIndex > 5) {
          wheelIndex = randIndex - 4;
        }
        if (randIndex == 9 || randIndex == 10 || randIndex == 11) {
          // 第三方奖品，对结果弹窗加上类名，禁止关闭，引导用户去兑换奖品
          this.dialogTrigger.classList.add("third-party-prize");
        }
        switch (randIndex) {
          case 1:
            // 处理奖品 1（盖子） 的逻辑
            this.capIndex = 0;
            break;
          case 2:
            this.capIndex = 1;
            break;
          case 3:
            this.capIndex = 2;
            break;
          case 4:
            this.capIndex = 3;
            break;
          case 5:
            this.capIndex = 4;
            break;
          default:
            this.capIndex = -1; // 非盖子奖品
        }

        // 2. 计算目标基准角度：使得该扇区的中心对准正上方指针 (0度)
        // 扇区中心角度 = initOffset + (index + 0.5) * step
        let targetBase =
          (this.initOffset + (wheelIndex + 0.5) * this.step) % 360;
        // 处理负值 (但initOffset为正，不必要)

        // 3. 当前角度模360
        let currentBase = ((this.currentDeg % 360) + 360) % 360; // 保证正数

        // 4. 计算从 currentBase 到 targetBase 的最短正增量 (0~360)
        let delta = (targetBase - currentBase + 360) % 360;

        // 5. 增加随机圈数 (3~6圈)，让转盘转得更自然
        const extraTurns = 3 + Math.floor(Math.random() * 4); // 3,4,5,6 圈
        delta += extraTurns * 360;

        // 6. 更新累计角度
        this.currentDeg += delta;

        // 7. 应用旋转 (css变换)
        this.wheel.style.transform = `rotate(${this.currentDeg}deg)`;

        // 8. 禁用按钮，开启旋转锁
        this.isSpinning = true;
        // this.spinBtn.disabled = true;

        // 9. 派发 input 事件，qikify 才能正确更新数据

        this.qikifyFormPrizeInput.value = this.prizes[randIndex].name;
        this.qikifyFormPrizeInput.dispatchEvent(
          new Event("input", { bubbles: true }),
        );
      }
      connectedCallback() {
        this.checkQikifyForm();
        this.json = JSON.parse(this.querySelector("[data-json]").textContent);
        // --- 用户配置区 (根据您的转盘图修改) ---
        // 奖品列表 (顺序必须与转盘图片扇区一致，从12点钟方向开始逆时针或顺时针？)
        // 注意：默认示例图片为8个扇区，颜色顺序如上svg，从12点起顺时针依次对应下方数组。
        // 如果您的图片不同，请修改 prizes 数量和名称，并调整 initOffset 使第一个扇区中心指向12点
        this.prizes = [
          { name: "V100", weight: 0 },
          { name: "Cap-1", weight: 0 },
          { name: "Cap-2", weight: 0 },
          { name: "Cap-3", weight: 0 },
          { name: "Cap-4", weight: 0 },
          { name: "Cap-5", weight: 0 },
          { name: "5%", weight: 5 },
          { name: "10%", weight: 14 },
          { name: "20%", weight: 5 },
          { name: "JOYROOM", weight: 0 },
          { name: "Twinkmont", weight: 0 },
          { name: "LUMIBRICKS", weight: 0 },
          { name: "Stickers", weight: 0 },
        ];

        // 初始偏移角度 initOffset (单位：度)
        // 用于微调：如果图片0°方向(正上方)与第一个扇区(索引0)的起始边界有夹角，请设置此值。
        // 若图片0°方向正好是扇区0的起始边界，则initOffset = 0
        // 若扇区0的起始边界在图片顺时针15°位置，则initOffset = 15
        this.initOffset = 0; // 默认0，若指针偏一个扇区可调整

        // --- 内部逻辑 ---
        this.N = 9; // 扇区数量
        this.capSize = 5; // 盖子类型数量
        this.step = 360 / this.N; // 每个扇区角度
        this.wheel = this.querySelector("#wheelImage");
        this.spinBtn = this.querySelector("#spinBtn");
        this.prizeNameSpan = this.querySelector("#prizeName");
        this.dialogTrigger = this.querySelector("easter-dialog-trigger");
        // this.prizeListDiv = this.querySelector("#prizeList");

        // 渲染奖品列表（仅展示）
        // this.prizeListDiv.innerHTML = this.prizes
        //   .map((p, idx) => `<span>${p}</span>`)
        //   .join("");

        // 当前累计旋转角度 (绝对角度，无模)
        this.currentDeg = 0;
        // 是否正在旋转
        this.isSpinning = false;
        // 缓存当前旋转的奖品索引
        this.currentPrizeIndex = -1;

        // 初始化显示第一个奖品 (可选)
        // this.prizeNameSpan.textContent = this.prizes[0];

        // 抽奖点击
        this.addEventListener("spin", this.handleSpin.bind(this));
        // this.spinBtn.addEventListener("click", this.handleSpin.bind(this));

        // 监听旋转结束，更新结果
        this.wheel.addEventListener("transitionend", (e) => {
          // 防止捕获其他属性的过渡 (只有transform才处理)
          if (e.propertyName !== "transform") return;
          if (!this.isSpinning) return; // 避免意外

          // 根据保存的 currentPrizeIndex 显示结果
          console.log("currentPrizeIndex", this.currentPrizeIndex);
          // if (this.currentPrizeIndex >= 0 && this.currentPrizeIndex < this.N) {
          //   this.prizeNameSpan.textContent = this.prizes[this.currentPrizeIndex];
          // } else {
          //   this.prizeNameSpan.textContent = "🎉";
          // }

          this.dialogTrigger.click();
          document
            .querySelector("#" + this.dialogTrigger.dataset.dialogTrigger)
            .setAttribute("data-prize-index", this.currentPrizeIndex);
          // document
          //   .querySelector(
          //     "#" + this.dialogTrigger.dataset.dialogTrigger + " [data-cap]",
          //   )
          //   .setAttribute("data-cap", this.capIndex);
          this.qikifyFormSubmitButton.click();

          // 启用按钮
          this.isSpinning = false;
          // this.spinBtn.disabled = false;

          // 可选：在控制台输出最终角度，方便调试偏移量
          console.log(
            `转到角度: ${this.currentDeg % 360}°，对应奖品: ${this.prizes[this.currentPrizeIndex]}`,
            this.currentPrizeIndex,
            this.capIndex,
          );
          if (this.currentPrizeIndex == 1) {
            if (this.capIndex == 0) {
              window.prizeStyle = 10;
            } else if (this.capIndex == 1) {
              window.prizeStyle = 11;
            } else if (this.capIndex == 2) {
              window.prizeStyle = 12;
            } else if (this.capIndex == 3) {
              window.prizeStyle = 13;
            } else if (this.capIndex == 4) {
              window.prizeStyle = 14;
            } else if (this.capIndex == 5) {
              window.prizeStyle = 15;
            }
          } else {
            window.prizeStyle = this.currentPrizeIndex;
          }
          // document.querySelector("#share-download").href="https://cdn.shopify.com/s/files/1/0703/2389/6537/files/gan-share-"+window.prizeStyle+".png";
          document
            .querySelector("#share-download")
            .addEventListener("click", async (e) => {
              e.preventDefault();
              this.downloadImage();
            });
        });

        // 保险：如果某些浏览器transitionend没触发（比如被中断），加一个备用定时器
        // 但基本都可靠，这里只加一个极简防呆
        // this.spinBtn.addEventListener("mousedown", (e) => {
        //   // 无特殊处理，但确保连续点击不会冲突
        // });

        // 手动修正：如果用户想校准偏移，可以通过此函数 (在控制台调用 setOffset(10) )
        window.setOffset = (offsetDeg) => {
          // 动态调整偏移，慎用。会重置当前旋转？
          console.warn(
            "手动调整 initOffset 为",
            offsetDeg,
            "度。已重置旋转角度0，请重新抽奖",
          );
          // 重置旋转到0度方便测试
          this.initOffset = offsetDeg; // 但const定义，此处仅为示意；实际用var定义
          // 由于上面const声明，无法修改。如需动态调整，可改为let定义，但为简化，建议直接修改源码中的initOffset
          alert(
            "要修改initOffset请直接编辑代码开头的initOffset值，然后刷新页面。",
          );
        };

        // 说明：如果指针指向总差半个扇区，可调整initOffset +/- (step/2) 左右
        // 将initOffset变量改为let以支持控制台调整(但为了代码清晰，已用const，如有需要可自行更改)
        // 为了方便调试，下面附加一个方法在控制台修改并重置
        // 实际推荐用户根据图片微调 initOffset 值 (0~360)
        console.log(
          "抽奖转盘已就绪。若指针指向偏移，请修改代码中 initOffset 值 (当前: 0°)",
        );

        // 额外的辅助: 展示当前角度与奖品 (非必须)
      }
    },
  );
}

// 分享气泡
document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll(".popup-trigger");

  links.forEach((link) => {
    // 把气泡移动到body
    const exitPop = link.querySelector(".exit-pop");

    document.body.appendChild(exitPop);
    // 鼠标事件 - PC端
    link.addEventListener("click", (e) => {
      if (exitPop) {
        exitPop.style.setProperty("--x", `${link.getBoundingClientRect().x}px`);
        exitPop.style.setProperty("--y", `${link.getBoundingClientRect().y}px`);
        exitPop.classList.toggle("active");
      }
    });
    // 监听滚动
    window.addEventListener("scroll", () => {
      if (exitPop) {
        exitPop.style.setProperty("--x", `${link.getBoundingClientRect().x}px`);
        exitPop.style.setProperty("--y", `${link.getBoundingClientRect().y}px`);
      }
    });
  });

  // const url = window.location.href;
  // const title = document.title;

  // // ✅ Facebook
  // document.getElementById("share-facebook").href =
  //   `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;

  // // ✅ X (Twitter)
  // document.getElementById("share-x").href =
  //   `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`;

  document
    .getElementById("share-facebook")
    .addEventListener("click", function () {
      const pageUrl = window.location.origin + window.location.pathname;
      const searchParams = new URLSearchParams(window.location.search);
      if (window.prizeStyle) {
        searchParams.set("style", window.prizeStyle);
      }
      const url = pageUrl + "?" + searchParams.toString();
      console.log(
        "share facebook, style:",
        window.prizeStyle,
        `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      );
      this.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    });
  document
    .getElementById("share-twitter")
    .addEventListener("click", function () {
      const pageUrl = window.location.origin + window.location.pathname;
      const searchParams = new URLSearchParams(window.location.search);
      if (window.prizeStyle) {
        searchParams.set("style", window.prizeStyle);
      }
      const url = pageUrl + "?" + searchParams.toString();
      const title = document.title;
      this.href = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`;
    });
});

document.querySelectorAll("[data-code]").forEach((code) => {
  code.addEventListener("click", () => {
    navigator.clipboard.writeText(code.dataset.code);
    code.classList.add("copied");
    setTimeout(() => {
      code.classList.remove("copied");
    }, 2000);
  });
});
